module.exports = __webpack_public_path__ + "img/unselected_icon.4efe7174.svg";